import styled from 'styled-components';

const Navigation = styled.div`
  display: flex;
  gap: 70px;
  align-items: center;
`

export default Navigation;
